export const ON_DUTY_COLOR = 'limegreen'

export const CMSI_1010_BACKGROUND_COLOR = 'lightgreen'
export const CMSI_2000_BACKGROUND_COLOR = 'plum'
export const CMSI_UPPER_DIVISION_BACKGROUND_COLOR = 'lightskyblue'
export const CMSI_GRAD_BACKGROUND_COLOR = 'gold'
